import ApiService from "../services/api";

export const fetchAlertsOrThrow = async (body: any): Promise<any[]> => {
  const apiService = new ApiService(import.meta.env.VITE_ALERTS_URL, 'rio-maintenance');
  const response = await apiService.post<any>(`/faultCodes`, body, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (response.status !== 200) {
    throw new Error(`Unexpected status ${response.status} from /faultCodes`);
  }
  return response.data?.data ?? [];
};

export const fetchAlerts = async (body: any): Promise<any[]> => {
  try {
    return await fetchAlertsOrThrow(body);
  } catch (error) {
    console.error("Erro ao buscar alertas:", error);
    return [];
  }
};
